module.exports = __webpack_public_path__ + "img/Beifahrerseite_1T_Heckmotor.e381f165.jpg";